import { render } from "./LessonDogsTopic4.vue?vue&type=template&id=55a76c48"
import script from "./LessonDogsTopic4.vue?vue&type=script&lang=js"
export * from "./LessonDogsTopic4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__